const _window: any = window;

export const environment = {
  isMobile: false,
  production: false,
  apiUrl: _window.env.apiUrl,
  baseUrl: _window.env.baseUrl,
  clientId: _window.env.clientId,
  authority: _window.env.authority,
  analyticsEnabled: _window.env.analyticsEnabled,
  matomoKey: _window.env.matomoKey,
  useMatomo: _window.env.useMatomo
};
